import VueRouter from 'vue-router'
const Home = ()=> import('@/pages/Home')
const About = ()=> import('@/pages/About')
const News = ()=> import('@/pages/News')
const NewsDet = ()=> import('@/pages/News/detail.vue')
const Download = ()=>  import('@/pages/Download')
const Innovation = ()=> import('@/pages/Innovation')
const Product = () => import('@/pages/Product')
const Module = () => import('@/pages/Product/module.vue')
const Dealer = () => import('@/pages/Product/dealer.vue')
const Solution = () => import('@/pages/Solution')
const Case = () => import('@/pages/Case')
const Sustain = () => import('@/pages/Sustain')

export default new VueRouter({
    mode:'history',
    routes:[
        {
            path: '/jp',
            component: Home
        },
        {
            path: '/jp/about',
            component: About
        },
        {

            name:'news',
            path:'/jp/news',
            component: News,
            props({query}){
                return { rmd: query.rmd, p:query.p }
            }
        },
        {
            path: '/jp/newsdet',
            component: NewsDet,
            props({query}){
                return { id:query.id }
            }
        },
        {
            name: 'load',
            path: '/jp/download',
            component: Download,
            props({query}){
                return { pid:query.pid, cid:query.cid, p:query.p }
            }
        },
        {
            path: '/jp/innovation',
            component: Innovation
        },
        {
            path: '/jp/product',
            component: Product,
            props({query}){
                return { id:query.id }
            }
        },
        {
            path:'/jp/module',
            component: Module
        },
        {
            path:'/jp/dealer',
            component: Dealer
        },
        {
            path: '/jp/solution',
            component: Solution,
            props({query}){
                return{ id:query.id }
            }
        },
        {
            name:'case',
            path:'/jp/case',
            component:Case,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path:'/jp/sustainability',
            component: Sustain
        }
    ]
})
